import { render } from "./Tabs.vue?vue&type=template&id=5a33216e&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=5a33216e&lang=scss&scoped=true"

import exportComponent from "../../../MemberPortal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a33216e"]])

export default __exports__